import "../css/app.scss";
import axios from "axios";

import { Ziggy } from "./ziggy.js";
import Router from "../../vendor/tightenco/ziggy/src/js/Router.js";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let router = new Router("", {}, false, Ziggy);

window.route = (name, params, absolute) => {
  Ziggy.url = import.meta.env.VITE_ROUTE_URL.replace(/\/+$/, "");
  router = new Router(name, params, absolute, Ziggy);
  return name ? router.replace(/\/+$/, "") : router;
};

window.activeRoute = (name) => {
  return router.current().match(name);
};
